import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Ensures every new screen/route starts scrolled to the top (mobile + desktop).
export function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}
